import { takeEvery } from 'redux-saga';

import { init as coreInit } from '../../core/js/components/coreComponent';
import { APP_INITIALIZED, saveInitialValues } from '../../core/js/actions/initialActions';
import { debug } from '../../core/js/utils/logger';
import { hasScope } from '../../core/js/utils/loginUtils';

const storeStack = [];
const profileStack = [];
let store;

/**
 * Resolve an Angular deferred with
 * the Redux store
 * @param  {object} deferred $q defer resolved with the Redux store
 */
export const resolveStore = (deferred) => {
    if (store) {
        deferred.resolve(store);
    } else {
        storeStack.push(deferred);
    }
};

export const resolveProfile = (deferred) => {
    if (store) {
        const state = store.getState();
        const profile = _.get(state, 'core.profile');

        if (hasScope('GUEST')) {
            deferred.resolve(profile);
        } else if (profile && profile.profileId) {
            deferred.resolve(profile);
        } else {
            profileStack.push(deferred);
        }
    } else {
        profileStack.push(deferred);
    }
};

export const receivedProfile = (profile) => {
    while (profileStack.length > 0) {
        resolveProfile(profileStack.pop());
    }
};

/**
 * Once the A15 Redux store is created,
 * resolve any pending Angular promises.
 */
function emptyStoreStack() {
    while (storeStack.length > 0) {
        resolveStore(storeStack.pop());
    }
}

/**
 * Create an A15 Redux store.
 * @param  {Function} initStore A15 Redux Store Generator
 * @return {Object}             Redux store
 */
export const createStore = (reduxStore) => {
    debug('Redux Store created. Resolving all Angular promises.');
    store = reduxStore;
    emptyStoreStack();

    // dispatch manually here to allow core.initialSaga
    // to run immediately and prevent a race condition
    // between makeRequest and the existence of the core store
    store.dispatch(saveInitialValues());

    $(document).ready(() => {
        coreInit(store);
        debug('Redux Core Store Initialized');

        window.__store = store;
    });

    return store;
};

/**
 * Once the A15 Core store has been initialized,
 * save a global of the Redux getState function
 * and resolve any pending Angular promises.
 * @param  {function} gs Redux State Function
 */
function* handleAppInitializedSaga() {
    debug('App Initialized. Resolving all Angular promises.');

    emptyStoreStack();
}

/**
 * Listener for the A15 Core store initialized action
 * @take  {APP_INITIALIZED}
 */
function* onAppInitializedSaga() {
    yield* takeEvery(APP_INITIALIZED, handleAppInitializedSaga);
}

/**
 * List of sagas required to make the interface work
 * @type {Array}
 */
export const interfaceSagas = [
    onAppInitializedSaga
];
